import React, { useRef } from 'react'
import { Outlet } from 'react-router-dom'
import Footer from './footer'

import Header from './header'

const Layout = () => {
  const refTabOurSolution = useRef()
  return (
    <>
      <Header refTabOurSolution={refTabOurSolution}/>
      <Outlet context={{ refTabOurSolution }} />
      <Footer/>
    </>
  )
}

export default Layout
